// @flow
import { authenticatedFetch } from '../../api/request';

const getAllCoaches = async (orgId: number) => {
    return await authenticatedFetch(`/v5/orgs/${orgId}/assistantCoaches`);
};

export default getAllCoaches;
